import { Injectable } from '@angular/core';
import { portalConst } from '@app/config';
import { Observable } from 'rxjs';
import { ApiService, Resp } from './api.service';
import { CrudService } from './crud.service';

@Injectable({ providedIn: 'root' })
export class SystematicService extends CrudService<any> {
  constructor(api: ApiService) {
    super(api, `${portalConst.api.eclass}/v1/links`);
  }

  public getSystematicEntity(data: any, headers?: any): Observable<Resp<any[]>> {
    return this.api.get(`${this.url}/links-entity`, data, headers);
  }
}
